import categories from './reducers'

export { addCategories } from './actions'
export { getCategoriesInMenu, getTopCategoriesInMenu, getTopCategoriesWithNestedDishes } from './selectors'

export default categories
